import { sanitizeHtml } from 'custom/core/sanitizeHtml'

const TEXT_COMPONENT_NAME = 'hotpay-text'

/**
 * Sanitizes (in place) the HTML `data.content` of every `hotpay-text` component in the given rows.
 *
 * Only `hotpay-text` holds HTML. `hotpay-title`/`hotpay-subtitle` hold plain text (taken from innerText),
 * so they are intentionally left untouched: running them through the HTML sanitizer would change
 * their text (e.g. `a < b`). On save they are renamed to `hotpay-text` by the API layer.
 */
export default function sanitizeTextComponents (rows) {
  if (!Array.isArray(rows)) return rows

  rows.forEach(row => {
    if (!row || !Array.isArray(row.columns)) return
    row.columns.forEach(column => {
      if (!column || !Array.isArray(column.components)) return
      column.components.forEach(component => {
        if (component && component.name === TEXT_COMPONENT_NAME && component.data && typeof component.data.content === 'string') {
          component.data.content = sanitizeHtml(component.data.content)
        }
      })
    })
  })

  return rows
}
